import { NgModule } from '@angular/core';
import { SelectRoleComponent } from './select-role.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    SelectRoleComponent
  ],
  exports: [
    SelectRoleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    DialogsModule,
    ButtonsModule,
    DropDownsModule
  ]
})
export class SelectRoleModule { }
